import { analyticEvent, inlineErrorEvent, overlayEvent } from './common';

export const unsubscribeFromTelemarketing = analyticEvent('marketing preferences: unsubscribe from phone calls button');

export const noPhoneOverlayEvent = overlayEvent('remove from call list: add number');

const phoneOverlayText = 'remove from call list';
export const phoneOverlayEvent = overlayEvent(phoneOverlayText);
export const phoneOverlayError = inlineErrorEvent(phoneOverlayText);

export const telemarketingOptOut = analyticEvent('mktg pref:call list>n');
